import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/grid",
  name: "/grid",
  redirect: {
    name: "grid",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/grid/list",
      name: "gridList",
      meta: {
        ...meta,
        title: "网格管理",
        cache: true,
      },
      component: () => import("@/pages/grid/GridList.vue"),
    },
    {
      path: "/grid/draw",
      name: "gridDraw",
      meta: {
        ...meta,
        cache: false,
        title: "网格绘制",
      },
      component: () => import("@/pages/grid/GridDraw.vue"),
    },
    {
      path: "/grid/dotsList",
      name: "gridDotsList",
      meta: {
        ...meta,
        title: "点位管理",
        // cache: true,
      },
      component: () => import("@/pages/grid/DotsList.vue"),
    },
    {
      path: "/grid/memberlist",
      name: "gridMemberList",
      meta: {
        ...meta,
        title: "网格员管理",
        cache: true,
      },
      component: () => import("@/pages/gridMember/GridMemberList.vue"),
    },
    {
      path: "/grid/memberadd",
      name: "gridMemberAdd",
      meta: {
        ...meta,
        title: "新增网格员",
        // cache: true,
      },
      component: () => import("@/pages/gridMember/GridMemberAdd.vue"),
    },
  ],
};
